import * as React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@spaced-out/ui-lib/lib/button'. '/Users/diwaker/SpacedOut/ui-server/node_modules/@spaced-out/ui-lib/lib/button/index.js' implicitly has an 'any' type.
import {UnstyledButton} from '@spaced-out/ui-lib/lib/button';

import classify from 'src/utils/classify';

import css from './tab-group.css';


export function TabGroup<T extends string>({
  tabs,
  currentTab,
  onChange,
  children,
}: {
  tabs: Array<{
    id: T;
    title: string;
    error?: unknown;
    content: React.ReactNode;
  }>;
  currentTab: T;
  onChange: (arg1: T) => unknown;
  children: React.ReactNode;
}) {
  return (
    <>
      <div className={css.tabBar}>
        {tabs.map((tab) => (
          <UnstyledButton
            className={classify(
              css.tab,
              currentTab === tab.id && css.active,
              tab.error && css.error,
            )}
            key={tab.id}
            onClick={() => onChange(tab.id)}
          >
            {tab.title}
          </UnstyledButton>
        ))}
      </div>
      <div className={css.body}>
        {tabs.find((tab) => tab.id === currentTab)?.content}
        {children}
      </div>
    </>
  );
}
